// Enums
import { StationType } from '../enums/stationType'

// Types
import { ICountryDTO } from '../types/country'

export interface IStationDTO {
    id: string
    label: string
    masterUrl: string
    countryId: string
    icon: string
    parentStationId?: string
    domainId: string
    departmentId: string
    regionId: string
    type: string
}

export interface IParentStation {
    id: string
    label: string
    masterUrl: string
    placeUrl: string
    icon: string
    domainId: string
    departmentId: string
    type?: string
}

export interface IStation {
    label: string
    id: string
    stations?: IStation[]
    type: string
    countryId: string
}

export interface IStationCountry {
    label: string
    items: IStation[]
}

export interface ICountry {
    label: string
    type: string
    id: string
    items?: IStation[]
}

export class StationData {
    stations: IStationDTO[]
    parentStations: IParentStation[]
    countries: ICountryDTO[]
    constructedStationCountries: ICountry[]
    constructor(stations: IStationDTO[], parentStations: IParentStation[], countries: ICountryDTO[]) {
        if (!stations) throw new Error('stations are mandatory in StationData')
        if (!parentStations) throw new Error('parentStations are mandatory in StationData')
        if (!countries) throw new Error('countries are mandatory in StationData')

        this.stations = stations
        this.parentStations = parentStations
        this.countries = countries
        this.constructedStationCountries = this.constructStationMap()
    }
    private constructStationMap(): ICountry[] {
        // Set the type as station
        this.stations.forEach((station) => {
            station.type = StationType.STATION
        })

        const stationWithoutParentStation = this.stations.filter((station) => !station.parentStationId)
        const stationWithParentStation = this.stations.filter((station) => station.parentStationId)

        const groupedStationsByParent = this.groupStationsByParentStation(stationWithParentStation)
        // Group by country id
        // First get all the country ids
        const countryIds = new Set(this.stations.map((station) => station.countryId))
        const consturctedCountries: ICountry[] = []

        // First geoup by country
        for (const countryId of countryIds) {
            const foundCountry: ICountryDTO | undefined = this.countries.find((country) => country.id === countryId)
            if (!foundCountry) {
                continue
            }
            const constructedCountry: ICountry = {
                label: foundCountry?.label,
                type: StationType.STATION,
                id: foundCountry?.id
            }

            consturctedCountries.push(constructedCountry)
        }

        const constructedStations = [...stationWithoutParentStation, ...groupedStationsByParent]

        for (const station of constructedStations) {
            const foundCountry: ICountry | undefined = consturctedCountries.find((country) => country.id === station.countryId)
            if (!foundCountry) continue
            if (!foundCountry.items) {
                foundCountry.items = [station]
            } else {
                foundCountry.items.push(station)
            }
        }

        return consturctedCountries
    }

    private groupStationsByParentStation(stationWithParentStation: IStationDTO[]): IStation[] {
        if (!stationWithParentStation) throw new Error('stationWithParentStation are mandatory in groupStationsByParentStation')
        const groupedStationsByParent: IStation[] = []
        for (const parentStation of this.parentStations) {
            const groupedStations = stationWithParentStation.filter((item: IStationDTO) => item.parentStationId === parentStation.id)
            const parentStationId = parentStation.id
            const parentStationLabel = parentStation.label
            groupedStationsByParent.push({
                id: parentStationId,
                label: parentStationLabel,
                stations: groupedStations,
                type: StationType.PARENT_STATION,
                countryId: groupedStations[0].countryId
            })
        }

        return groupedStationsByParent
    }
}
